import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Translate } from "@common/models";
import { environment } from "environments/environment";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";

@Injectable({providedIn: 'root'})
export class BelivTranslateService{


    /**
     * Constructor for the service
     * @param _http client
     */
    constructor(private _http: HttpClient){};


    /**
     * Return all translations 
     * @returns object with translation data
     */
    getAll(): Observable<Translate[]>{
        //return this._http.get<Language[]>(`${environment.commonApiUrl}/api/language`);
        return this._http.get<Translate[]>(`${environment.commonApiUrl}/api/translate/all`).pipe(map((resp: any) => resp as Translate[]));
    }

    

}
